"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../Input"));

var _reactTextMask = require("react-text-mask");

var _createNumberMask = _interopRequireDefault(require("text-mask-addons/dist/createNumberMask"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NumberInput = _react["default"].forwardRef(function (_ref, ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      precision = _ref.precision,
      decimalSeparator = _ref.decimalSeparator,
      thousandSeparator = _ref.thousandSeparator,
      props = _objectWithoutProperties(_ref, ["value", "onChange", "precision", "decimalSeparator", "thousandSeparator"]);

  var input = _react["default"].useRef();

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectionStart = _React$useState2[0],
      setSelectionStart = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectionEnd = _React$useState4[0],
      setSelectionEnd = _React$useState4[1]; // create mask function depending on props


  var mask = _react["default"].useMemo(function () {
    return (0, _createNumberMask["default"])({
      allowDecimal: precision > 0,
      decimalLimit: precision,
      allowNegative: false,
      thousandsSeparatorSymbol: thousandSeparator,
      decimalSymbol: decimalSeparator,
      prefix: ''
    });
  }, [precision, thousandSeparator, decimalSeparator]); // parses masked string value into unmasked number


  var parse = function parse(v) {
    var value = parseFloat(v.replace(new RegExp(thousandSeparator, "g"), ''));
    if (isNaN(value)) return undefined;
    return value;
  }; // create masked string value


  var strValue = value !== undefined && value !== null ? value.toString() : '';

  var _conformToMask = (0, _reactTextMask.conformToMask)(strValue, mask, {
    guide: false
  }),
      conformedValue = _conformToMask.conformedValue; // update input value and cursor position on every edit


  _react["default"].useEffect(function () {
    input.current.value = conformedValue;
    input.current.selectionStart = selectionStart;
    input.current.selectionEnd = selectionEnd;
  }, [value]); // manipulate cursor position to handle some special cases


  var handleKeyDown = _react["default"].useCallback(function (e) {
    var key = e.key;
    var value = e.target.value;
    var currentStart = e.target.selectionStart;

    if (precision > 0) {
      // if they type a . then move the dot to where they typed
      if (key == ".") {
        e.target.value = value.replace(".", ""); // reset cursor position because the value is possibly one char shorter

        e.target.selectionStart = e.target.selectionEnd = currentStart;
        setSelectionStart(currentStart);
        setSelectionEnd(currentStart);
      }
    } // delete characters across the comma with backspace and delete key


    var backspaceComma = key == "Backspace" && value[currentStart - 1] == ",";
    var deleteComma = key == "Delete" && value[currentStart] == ",";

    if (backspaceComma || deleteComma) {
      var newIdx;

      if (backspaceComma) {
        newIdx = currentStart - 1;
      } else {
        newIdx = currentStart + 1;
      }

      setSelectionStart(newIdx);
      setSelectionEnd(newIdx);
      e.target.selectionStart = e.target.selectionEnd = newIdx;
    }
  }, []);

  var handleChange = _react["default"].useCallback(function (e) {
    var _e$target = e.target,
        value = _e$target.value,
        selectionStart = _e$target.selectionStart,
        selectionEnd = _e$target.selectionEnd; // strip off leading 0 which causes mask to fail

    if (value.length > 1 && value.startsWith("0")) {
      value = value.substr(1);
    }

    var _conformToMask2 = (0, _reactTextMask.conformToMask)(value, mask, {
      guide: false
    }),
        conformedValue = _conformToMask2.conformedValue; // add back in leading 0 if decimal is first


    if (conformedValue.startsWith(decimalSeparator)) {
      conformedValue = "0" + conformedValue;
    }

    var decimalIdx = value.indexOf('.');
    var afterDecimal = decimalIdx > -1 && selectionStart > decimalIdx; // handle cases where commas are added/removed
    // we only care about adjusting if we're before the decimal point
    // since that's where commas are

    if (!afterDecimal) {
      if (conformedValue.length > e.target.value.length) {
        selectionStart++;
        selectionEnd++;
      } else if (conformedValue.length < e.target.value.length) {
        selectionStart--;
        selectionEnd--;
      }
    }

    e.target.value = conformedValue;
    var parsed = parse(conformedValue);
    setSelectionStart(selectionStart);
    setSelectionEnd(selectionEnd);
    e.persist();
    e.target = {
      value: parsed
    };
    onChange(e);
  });

  return _react["default"].createElement(_Input["default"], _extends({
    ref: _react["default"].useCallback(function (el) {
      applyRef(input, el);
      applyRef(ref, el);
    }, []),
    textAlign: "right",
    onKeyDown: handleKeyDown,
    onChange: handleChange
  }, props));
});

NumberInput.propTypes = {
  precision: _propTypes["default"].number,
  allowNegative: _propTypes["default"].bool
};
NumberInput.defaultProps = {
  precision: 0,
  allowNegative: false,
  decimalSeparator: '.',
  thousandSeparator: ','
};
var _default = NumberInput;
exports["default"] = _default;

var applyRef = function applyRef(ref, el) {
  if (ref && _typeof(ref) === 'object') ref.current = el;
  if (typeof ref === 'function') ref(el);
};